import axios from "axios";
import { Base_URL } from "../url";

export const saveUnitDetails = async (unitData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/UnitMaster/CreateUnit?UserName=${userName}`,
      unitData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving unit details!";
  }
};

export const getUnits = async (userName) => {
  try {
    const response = await axios.get(
      `${Base_URL}/UnitMaster/GetAllUnits?UserName=${userName}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching units!";
  }
};